package one.healthium.featureconfig.domain

object CoreFeatureConfigSchema : FeatureConfigSchema {
    override val keys: Set<ConfigKey<*>> = setOf(
        CoreFeatureConfigKeys.ManageSubscription,
        CoreFeatureConfigKeys.EnableLogFoodScanner,
        CoreFeatureConfigKeys.Paywall,
        CoreFeatureConfigKeys.EnablePersonalMealPlan,
    )
}
